export default __webpack_public_path__ + "static/media/ConveyorLiftMK4.256.24e6d442.png";